/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable keyword-spacing */
import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';
import { Select } from 'primeng/select';
import { Subscription } from 'rxjs';

/**
 * cmg-p-select-blur-enhancer - a directive to trap the blur
 * event on p-select and show validation when required is set.
 * Why - b/c PrimeNG did not do it.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[cmg-p-select-blur-enhancer]',
})
export class CmgPrimeNgDropdownBlurDirective implements OnInit, OnDestroy {
  private readonly _dropdown = inject(Select);
  private readonly _control = inject(NgControl);
  private readonly _model = inject(NgModel, { optional: true });

  private _sub: Subscription;
  ngOnInit() {
    this._sub = this._dropdown.onBlur.subscribe(this._onDropdownBlur);
  }

  ngOnDestroy() {
    if (this._sub && !this._sub.closed) {
      this._sub.unsubscribe();
    }
  }

  private readonly _onDropdownBlur = ($event: any) => {
    if (this._control) {
      this._control.control?.markAsDirty();
      this._control.control?.markAsTouched();
      this._control.control?.updateValueAndValidity();
    }
  };
}
